import isEmpty from 'lodash-es/isEmpty';
import ebdcoms from '../../utils/ebdcoms';
import { StyleConfigAttrs } from '../../utils/page-style/types';
import { BackgroundType, FillMode } from './types';

/** 获取用户自定义的视频属性 */
const getVideoProps = (data: StyleConfigAttrs) => {
  let videoProps = {
    src: '',
  } as any;

  const { video } = data!;

  const src = ebdcoms.excu('getVideoSrc')(video?.url);

  videoProps = {
    src,
  };

  return videoProps;
};

/** 获取用户自定义的轮播图属性 */
const getPictureProps = (data: StyleConfigAttrs) => {
  let pictureProps = {
    autoplay: false,
  } as any;

  const { loop, speed, pictureSetting = [] } = data!;

  const activeIndex = pictureSetting.findIndex((item: any) => item.active);

  pictureProps = {
    initialSlide: activeIndex,
    autoplay: loop
      ? {
        delay: loop ? speed * 1000 : 3000,
      }
      : false,
    loop,
  };

  return pictureProps;
};

/** 获取用户自定义属性 */
export const getCustomProps = (data?: StyleConfigAttrs) => {
  let customProps = {
    src: '',
  } as any;

  if (isEmpty(data)) return customProps;

  const { type } = data!;

  if (type === BackgroundType.Video) {
    customProps = getVideoProps(data!);
  } else if (type === BackgroundType.Picture) {
    customProps = getPictureProps(data!);
  }

  return customProps;
};

/** 获取格式化后的视频样式 */
export const getFormatVideoStyles = (item?: StyleConfigAttrs, wrapRef?: HTMLDivElement) => {
  let styles = {
    position: 'absolute',
    width: '',
    height: '',
    top: '',
    left: '',
  };

  if (isEmpty(item) || isEmpty(wrapRef)) return styles;

  const wrapWidth = Number(wrapRef!.offsetWidth);
  const wrapHeight = Number(wrapRef!.offsetHeight);

  const { videoOriginWidth, videoOriginHeight } = item!;

  let formatWidth = wrapWidth;
  let formatHeight = (wrapWidth * videoOriginHeight) / videoOriginWidth;

  if (wrapHeight > formatHeight) {
    formatHeight = wrapHeight;
    formatWidth = (wrapHeight * videoOriginWidth) / videoOriginHeight;
  }

  const top = -(Math.abs(formatHeight - wrapHeight) / 2);
  const left = -(Math.abs(formatWidth - wrapWidth) / 2);

  styles = {
    ...styles,
    width: `${formatWidth}px`,
    height: `${formatHeight}px`,
    top: `${top}px`,
    left: `${left}px`,
  };

  return styles;
};

/** 获取图片样式 */
export const getPictureStyles = (item: StyleConfigAttrs, wrapRef?: HTMLDivElement) => {
  let styles = {};

  if (isEmpty(item) || isEmpty(wrapRef)) return styles;

  styles = {
    backgroundImage: `url(${ebdcoms.excu('getImgUrl')(item.url)})`,
  };

  // 填充效果参考E9实现效果
  switch (item.fillMode) {
    case FillMode.Fill:
    case FillMode.Fit: {
      styles = {
        ...styles,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      };

      const getImgUrl = ebdcoms.excu('getImgUrl');

      const image = new Image();
      image.src = getImgUrl(item.url);

      const imageWidth = Number(image.width);
      const imageHeight = Number(image.height);

      let _styles = {};

      const wrapWidth = Number(wrapRef!.offsetWidth);
      const wrapHeight = Number(wrapRef!.offsetHeight);

      const imgRate = imageWidth / imageHeight;
      const wrapRate = wrapWidth / wrapHeight;

      if (imgRate > wrapRate) {
        if (item.fillMode === FillMode.Fit) {
          _styles = {
            width: wrapWidth,
            height: wrapWidth / imgRate,
          };
        }

        if (item.fillMode === FillMode.Fill) {
          _styles = {
            width: wrapHeight * imgRate,
            height: wrapHeight,
            marginLeft: -((wrapHeight * imgRate - wrapWidth) / 2),
          };
        }
      } else if (imgRate < wrapRate) {
        if (item.fillMode === FillMode.Fit) {
          _styles = {
            width: wrapHeight * imgRate,
            height: wrapHeight,
            // swiper父级容器自带display: flex居中样式，不需要marginLeft样式
            // marginLeft: (wrapWidth - wrapHeight * imgRate) / 2,
          };
        }
        if (item.fillMode === FillMode.Fill) {
          _styles = {
            width: wrapWidth,
            height: wrapWidth / imgRate,
          };
        }
      } else {
        _styles = {
          width: wrapWidth,
          height: wrapHeight,
        };
      }

      styles = { ...styles, ..._styles };
      break;
    }

    case FillMode.Stretch:
      styles = {
        ...styles,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
      };
      break;
    case FillMode.Tile:
      styles = {
        ...styles,
        backgroundRepeat: 'repeat',
      };
      break;
    case FillMode.Center:
      styles = {
        ...styles,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      };
      break;

    default:
      styles = {
        ...styles,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
      };
      break;
  }

  return styles;
};

export const getIsEmptyPageBgConfig = (pageBgConfig?: StyleConfigAttrs) => {
  const { type, pictureSetting, video } = pageBgConfig || {};

  return (
    isEmpty(pageBgConfig)
    || !type
    || type === BackgroundType.None
    || (type === BackgroundType.Picture && !pictureSetting.length)
    || (type === BackgroundType.Video && !video.url)
  );
};

export default {};
